import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseFetch } from "../helpers/apiClient";
import { getWithExpiry } from "../helpers/authHelper.js";
import {
  setLoadingState,
  setFulfilledState,
  setRejectedState,
} from "../helpers/authHelper.js";

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (data) => {
    const response = await baseFetch({
      url: "/v1/auth/forgot-password",
      method: "POST",
      body: data,
    });

    return response;
  },
);

export const verifyForgotPwdCode = createAsyncThunk(
  "auth/verifyOtp",
  async (data) => {
    const response = await baseFetch({
      url: `/v1/auth/verify-otp`,
      method: "POST",
      body: data,
    });

    return response;
  },
);

export const resetPassword = createAsyncThunk(
  "auth/resetPassword",
  async (data) => {
    const response = await baseFetch({
      url: `/v1/auth/reset-password`,
      method: "POST",
      body: data,
    });

    return response;
  },
);

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (data) => {
    const response = await baseFetch({
      url: `/v1/web/profile/changePassword`,
      method: "POST",
      body: data,
    });
    return response;
  },
);

export const initialAuthState = {
  toast: null,
  terms: null,
  termsStatus: null,
  termsError: null,
  policy: null,
  policyStatus: null,
  policyError: null,
  loginDetails: getWithExpiry("loginDetails"),
  loginDetailsStatus: null,
  loginDetailsError: null,
  forgot: null,
  forgotStatus: null,
  forgotError: null,
  verify: null,
  verifyStatus: null,
  verifyError: null,
  resetPwd: null,
  resetPwdStatus: null,
  resetPwdError: null,
  verifyEmail: null,
  verifyEmailStatus: null,
  verifyEmailError: null,
  changePwd: null,
  changePwdStatus: null,
  changePwdError: null,
};

const authReducer = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    clearAuthData: (state) => {
      state.loginDetails = null;
      state.loginDetailsStatus = null;
      state.loginDetailsError = null;
      state.verifyEmail = null;
      state.verifyEmailStatus = null;
      state.verifyEmailError = null;
      localStorage.removeItem("persist:root");
    },
    clearLoginData: (state) => {
      state.loginDetails = null;
      state.loginDetailsStatus = null;
      state.loginDetailsError = null;
    },
    clearVerifyOtp: (state) => {
      state.verify = null;
      state.verifyStatus = null;
      state.verifyError = null;
    },
    clearEmailVerifyData: (state) => {
      state.verifyEmail = null;
      state.verifyEmailStatus = null;
      state.verifyEmailError = null;
    },
    clearForgotData: (state) => {
      state.forgot = null;
      state.forgotStatus = null;
      state.forgotError = null;
    },
    clearChangePasswordData: (state) => {
      state.changePwd = null;
      state.changePwdStatus = null;
      state.changePwdError = null;
    },
    clearResetPasswordData: (state) => {
      state.resetPwd = null;
      state.resetPwdStatus = null;
      state.resetPwdError = null;
    },
    showToastAuth: (state, action) => {
      state.toast = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(forgotPassword.pending, (state) =>
        setLoadingState(state, "forgot"),
      )
      .addCase(forgotPassword.fulfilled, (state, action) =>
        setFulfilledState(state, "forgot", action.payload),
      )
      .addCase(forgotPassword.rejected, (state, action) =>
        setRejectedState(state, "forgot", action.error),
      )

      .addCase(verifyForgotPwdCode.pending, (state) =>
        setLoadingState(state, "verify"),
      )
      .addCase(verifyForgotPwdCode.fulfilled, (state) =>
        setFulfilledState(state, "verify", null),
      )
      .addCase(verifyForgotPwdCode.rejected, (state, action) =>
        setRejectedState(state, "verify", action.error),
      )

      .addCase(resetPassword.pending, (state) =>
        setLoadingState(state, "resetPwd"),
      )
      .addCase(resetPassword.fulfilled, (state) =>
        setFulfilledState(state, "resetPwd", null),
      )
      .addCase(resetPassword.rejected, (state, action) =>
        setRejectedState(state, "resetPwd", action.error),
      )
      .addCase(changePassword.pending, (state) =>
        setLoadingState(state, "changePwd"),
      )
      .addCase(changePassword.fulfilled, (state) =>
        setFulfilledState(state, "changePwd", null),
      )
      .addCase(changePassword.rejected, (state, action) =>
        setRejectedState(state, "changePwd", action.error),
      );
  },
});

export const {
  clearAuthData,
  clearVerifyOtp,
  clearResetPasswordData,
  clearLoginData,
  clearEmailVerifyData,
  clearChangePasswordData,
  clearForgotData,
  showToastAuth,
} = authReducer.actions;

export default authReducer.reducer;
